// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MaximizeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MaximizeIcon" ref={forwardedRef} {...props}>
      <path d="M5.5 15.5 9 12l-1.06-1.06-3.44 3.439V11H3v6h6v-1.5z" />
      <path d="M17 3v6h-1.5V5.62l-3.44 3.44L11 8l3.5-3.5H11V3z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MaximizeIcon = /* @__PURE__ */ Object.assign(
  MaximizeIconComponent,
  { displayName: 'MaximizeIcon' },
);
